import React, { useLayoutEffect, useState } from "react";
import {
  Badge,
  List,
  Card,
  Row,
  Col,
  Input,
  Button,
  Space,
  Popconfirm,
  InputNumber,
  Divider,
  Select,
  Modal,
  Typography,
  Avatar,
} from "antd";
import {
  ACTIVE_PRODUCT,
  CREATE_ORDER,
  IMAGE_BASE_URL,
  ORDER_PAY_VERIFY,
} from "../../constants/api";
import { displayMessage, getAPI, postAPI } from "../../utils/common";
import Meta from "antd/es/card/Meta";
import { useParams, useNavigate } from "react-router-dom";
import {
  DeleteOutlined,
  RollbackOutlined,
  PrinterOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import { CURRENCY } from "../../constants/constent";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
const { Title, Text } = Typography;

const PlaceOrderForm = ({ pageFrom }) => {
  const { booking_id } = useParams();
  let navigate = useNavigate();

  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [cart, setCart] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [discountType, setDiscountType] = useState("percentage");
  const [taxRate, setTaxRate] = useState(0.05);
  const [orderNotes, setOrderNotes] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("PayOnCheckout");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [receiptData, setReceiptData] = useState(null);

  useLayoutEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setState(data["data"]);
        setFilteredData(data["data"]);
        setLoading(false);
      } else {
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };
    getAPI(ACTIVE_PRODUCT, successFn, errorFn, {});
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (room) =>
        room.product_name.toLowerCase().includes(value.toLowerCase()) ||
        room.product_amt.toString().includes(value)
    );
    setFilteredData(filtered);
  };

  const addToCart = (item) => {
    const existingItem = cart.find((cartItem) => cartItem.id === item.id);

    if (existingItem) {
      setCart(
        cart.map((cartItem) =>
          cartItem.id === item.id
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        )
      );
    } else {
      setCart([...cart, { ...item, quantity: 1 }]);
    }
  };

  const removeFromCart = (itemId) => {
    setCart(cart.filter((item) => item.id !== itemId));
  };

  const updateQuantity = (itemId, quantity) => {
    setCart(
      cart.map((item) =>
        item.id === itemId ? { ...item, quantity: Math.max(1, quantity) } : item
      )
    );
  };

  const calculateTotal = () => {
    const subtotal = cart.reduce(
      (total, item) => total + item.product_amt * item.quantity,
      0
    );
    const discountAmount = calculateDiscount();
    const tax = (subtotal - discountAmount) * taxRate;
    return subtotal - discountAmount + tax;
  };

  const calculateTax = () => {
    const subtotal = cart.reduce(
      (total, item) => total + item.product_amt * item.quantity,
      0
    );
    const discountAmount = calculateDiscount();
    return (subtotal - discountAmount) * taxRate;
  };

  const calculateDiscount = () => {
    const subtotal = cart.reduce(
      (total, item) => total + item.product_amt * item.quantity,
      0
    );
    const discountAmount =
      discountType === "percentage" ? (subtotal * discount) / 100 : discount;

    return discountAmount;
  };

  const generateReceipt = () => {
    const receipt = {
      items: cart,
      subtotal: cart.reduce(
        (total, item) => total + item.product_amt * item.quantity,
        0
      ),
      discount: discount,
      discountAmount: calculateDiscount(),
      discountType: discountType,
      tax: calculateTax(),
      total: calculateTotal(),
      orderNotes: orderNotes,
      paymentMethod: paymentMethod,
    };

    setReceiptData(receipt);
    setIsModalVisible(true);
  };

  const handleCheckout = () => {
    const body = {
      items: cart,
      subtotal: cart.reduce(
        (total, item) => total + item.product_amt * item.quantity,
        0
      ),
      discount: discount,
      discountAmount: calculateDiscount(),
      discountType: discountType,
      tax: calculateTax(),
      total: calculateTotal(),
      orderNotes: orderNotes,
      payment_method: paymentMethod,
      booking_id: booking_id,
    };

    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        displayMessage(SUCCESS_MESSAGE, data.message);
        if (data.payment_method === "razorpay") {
          const options = {
            key: data.options.key,
            amount: data.options.amount * 100,
            currency: data.options.currency,
            name: data.options.name,
            description: data.options.description,
            image: IMAGE_BASE_URL + data.options.image,
            order_id: data.options.order_id,
            prefill: {
              name: data.options.prefill.name,
              email: data.options.prefill.email,
              contact: data.options.prefill.contact,
            },
            handler: function (response) {
              let body = {
                ...response,
                order_id: data.order_id,
              };
              console.log(body);
              const successFn = function (data) {
                clearData();
                displayMessage(SUCCESS_MESSAGE, data.message);
                generateReceipt();
              };
              const errorFn = function () {
                displayMessage(
                  ERROR_MSG_TYPE,
                  "Unable to do payment verification"
                );
              };
              postAPI(ORDER_PAY_VERIFY, body, successFn, errorFn);
            },
            theme: {
              color: "#F37254",
            },
          };
          const razorpay = new window.Razorpay(options);
          razorpay.open();
        } else {
          clearData();
          generateReceipt();
        }
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to checkout");
    };
    postAPI(CREATE_ORDER, body, successFn, errorFn);

    console.log("Checkout:", body);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setReceiptData(null);
  };
  const handlePrintReceipt = () => {
    const modalContent = document.getElementById("receipt-modal-content");

    html2canvas(modalContent).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const thermalPrinterWidth = 320;
      const scaleFactor = thermalPrinterWidth / imgWidth;
      const doc = new jsPDF({
        unit: "px",
        format: [thermalPrinterWidth, imgHeight * scaleFactor],
      });
      doc.addImage(
        imgData,
        "PNG",
        0,
        0,
        imgWidth * scaleFactor,
        imgHeight * scaleFactor
      );

      const pdfData = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfData);
      const printWindow = window.open(pdfUrl, "_blank");
      printWindow.onload = () => {
        printWindow.print();
      };
    });
  };

  const clearData = () => {
    setCart([]);
    setDiscount(0);
    setDiscountType("percentage");
    setOrderNotes("");
    setPaymentMethod("PayOnCheckout");
    setReceiptData(null);
  };
  return (
    <>
      <Row gutter={[16, 16]}>
        {/* Product List Column */}
        <Col md={18}>
          <Card
            title="Select Product's"
            loading={loading}
            extra={
              <Space>
                <Input
                  placeholder="Search by Name or Price"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
                <Button
                  style={{
                    marginTop: "5px",
                    marginBottom: "5px",
                  }}
                  onClick={() => navigate(-1)}
                  type="primary"
                  ghost
                >
                  <RollbackOutlined />
                </Button>
              </Space>
            }
          >
            <List
              grid={{
                gutter: 16,
                xs: 1,
                sm: 2,
                md: 4,
                lg: 4,
                xl: 6,
                xxl: 6,
              }}
              dataSource={filteredData}
              renderItem={(item) => {
                const isInCart = cart.some(
                  (cartItem) => cartItem.id === item.id
                );
                return (
                  <List.Item>
                    <Badge.Ribbon
                      text={`${item.status ? "Active" : "Disabled"}`}
                      color={`${item.status ? "green" : "red"}`}
                    >
                      <Card
                        style={{
                          padding: "10px",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        key={item.id}
                        onClick={(e) => {
                          isInCart
                            ? updateQuantity(
                                item.id,
                                cart.find((cartItem) => cartItem.id === item.id)
                                  .quantity + 1
                              )
                            : addToCart(item);
                        }}
                        cover={
                          <img
                            alt="files"
                            src={
                              IMAGE_BASE_URL +
                              item.product_images[0].image.filePath
                            }
                            style={{
                              width: "100%",
                            }}
                          />
                        }
                      >
                        <Meta
                          title={`${item.product_name}`}
                          description={`${CURRENCY}${item.product_amt}`}
                        />
                      </Card>
                    </Badge.Ribbon>
                  </List.Item>
                );
              }}
            />
          </Card>
        </Col>

        {/* Cart Column */}
        <Col md={6}>
          <Card
            title={<Title level={5}>Cart</Title>}
            extra={
              <>
                <Row
                  gutter={[16, 16]}
                  style={{ float: "right", justifyContent: "right" }}
                >
                  <Col span={12}>
                    <InputNumber
                      disabled={pageFrom === "c_place_order"}
                      addonBefore="GST"
                      addonAfter="%"
                      placeholder="GST"
                      value={taxRate * 100}
                      onChange={(value) => setTaxRate(value / 100)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                </Row>
              </>
            }
          >
            {cart.length > 0 ? (
              <>
                <List
                  dataSource={cart}
                  renderItem={(item) => (
                    <List.Item
                      actions={[
                        <Popconfirm
                          title="Are you sure you want to remove this item?"
                          onConfirm={() => removeFromCart(item.id)}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button type="link" icon={<DeleteOutlined />} />
                        </Popconfirm>,
                        <InputNumber
                          min={1}
                          value={item.quantity}
                          onChange={(value) => updateQuantity(item.id, value)}
                          style={{ width: 60 }}
                        />,
                      ]}
                    >
                      <Row style={{ width: "100%" }}>
                        <Col
                          span={18}
                        >{`${item.product_name} (x${item.quantity})`}</Col>
                        <Col span={6} style={{ textAlign: "center" }}>
                          {CURRENCY}
                          {item.product_amt * item.quantity}
                        </Col>
                      </Row>
                    </List.Item>
                  )}
                />

                {/* Discount and Tax Inputs */}
                <Divider />
                <Row gutter={8} hidden={pageFrom === "c_place_order"}>
                  <Col span={12}>
                    <InputNumber
                      placeholder="Discount"
                      value={discount}
                      onChange={(value) => setDiscount(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col span={12}>
                    <Select
                      value={discountType}
                      onChange={(value) => setDiscountType(value)}
                      style={{ width: "100%" }}
                    >
                      <Select.Option value="percentage">
                        Percentage
                      </Select.Option>
                      <Select.Option value="flat">Flat</Select.Option>
                    </Select>
                  </Col>
                </Row>

                <Divider />
                <Row>
                  <Col span={18}>Subtotal:</Col>
                  <Col span={6} style={{ textAlign: "right" }}>
                    {CURRENCY}
                    {cart.reduce(
                      (total, item) => total + item.product_amt * item.quantity,
                      0
                    )}
                  </Col>
                </Row>
                <Divider />
                <Row>
                  <Col span={18}>Discount:</Col>
                  <Col span={6} style={{ textAlign: "right" }}>
                    {CURRENCY}
                    {calculateDiscount()}
                  </Col>
                </Row>
                <Row>
                  <Col span={18}>Tax ({taxRate * 100}%):</Col>
                  <Col span={6} style={{ textAlign: "right" }}>
                    {CURRENCY}
                    {calculateTax()}
                  </Col>
                </Row>

                <Divider />
                <Row>
                  <Col span={18}>Total:</Col>
                  <Col span={6} style={{ textAlign: "right" }}>
                    {CURRENCY}
                    {calculateTotal()}
                  </Col>
                </Row>

                {/* Payment and Checkout */}
                <Divider />
                <Title level={5}>Select Payment Method</Title>
                <Select
                  placeholder="Select Payment Method"
                  value={paymentMethod}
                  onChange={setPaymentMethod}
                  style={{ width: "100%" }}
                >
                  <Select.Option value="PayOnCheckout">
                    Checkout (Pay with room checkout)
                  </Select.Option>
                  <Select.Option
                    value="cash"
                    disabled={pageFrom === "c_place_order"}
                  >
                    Cash
                  </Select.Option>
                  <Select.Option value="razorpay">Razorpay</Select.Option>
                </Select>

                <Input.TextArea
                  rows={4}
                  value={orderNotes}
                  onChange={(e) => setOrderNotes(e.target.value)}
                  placeholder="Add order notes"
                  style={{ marginTop: "10px" }}
                />

                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Button
                      type="primary"
                      icon={<PrinterOutlined />}
                      onClick={generateReceipt}
                      style={{ width: "100%", marginTop: "20px" }}
                    >
                      Receipt
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      type="primary"
                      onClick={handleCheckout}
                      style={{ width: "100%", marginTop: "20px" }}
                    >
                      Checkout
                    </Button>
                  </Col>
                </Row>
              </>
            ) : (
              <Row>
                <Col span={24} style={{ textAlign: "center" }}>
                  <Avatar
                    size={64}
                    icon={<ShoppingCartOutlined />}
                    style={{
                      marginBottom: "10px",
                    }}
                  />
                  <Title level={5}>Your cart is empty.</Title>
                </Col>
              </Row>
            )}
          </Card>
        </Col>
      </Row>

      <Modal
        visible={isModalVisible}
        onCancel={closeModal}
        footer={null}
        width={600}
      >
        <div
          id="receipt-modal-content"
          style={{
            padding: "20px",
            border: "1px solid #f0f0f0",
            borderRadius: "10px",
            backgroundColor: "#f9f9f9",
          }}
        >
          <Row>
            <Col span={24} style={{ textAlign: "center" }}>
              <Avatar
                size={64}
                icon={<PrinterOutlined />}
                style={{
                  backgroundColor: "#1890ff",
                  marginBottom: "10px",
                }}
              />
              <Title level={2}>Receipt</Title>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Text strong>Items:</Text>
              <List
                dataSource={receiptData?.items || []}
                renderItem={(item) => (
                  <List.Item>
                    <Row style={{ width: "100%" }}>
                      <Col span={18}>
                        <Text>{item.product_name}</Text>
                      </Col>
                      <Col span={6} style={{ textAlign: "right" }}>
                        <Text>
                          {CURRENCY}
                          {item.product_amt * item.quantity}
                        </Text>
                      </Col>
                    </Row>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col span={18}>
              <Text strong>Subtotal:</Text>
            </Col>
            <Col span={6} style={{ textAlign: "right" }}>
              <Text>
                {CURRENCY}
                {receiptData?.subtotal || 0}
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={18}>
              <Text strong>Discount:</Text>
            </Col>
            <Col span={6} style={{ textAlign: "right" }}>
              <Text>
                {CURRENCY}
                {calculateDiscount() || 0}
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={18}>
              <Text strong>Tax:</Text>
            </Col>
            <Col span={6} style={{ textAlign: "right" }}>
              <Text>
                {CURRENCY}
                {receiptData?.tax || 0}
              </Text>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col span={18}>
              <Text strong>Total:</Text>
            </Col>
            <Col span={6} style={{ textAlign: "right" }}>
              <Text>
                {CURRENCY}
                {receiptData?.total || 0}
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={18}>
              <Text strong>Payment Method:</Text>
            </Col>
            <Col span={6} style={{ textAlign: "right" }}>
              <Text>{receiptData?.paymentMethod}</Text>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Text strong>Order Notes:</Text>
              <Text>{receiptData?.orderNotes || "N/A"}</Text>
            </Col>
          </Row>
          <Divider />
        </div>
        <Button
          type="primary"
          icon={<PrinterOutlined />}
          onClick={handlePrintReceipt}
          style={{ width: "100%" }}
        >
          Print Receipt
        </Button>
      </Modal>
    </>
  );
};

export default PlaceOrderForm;
